import { useEffect } from 'react';
import { SceneBack } from '@/shared/components/SceneBack';
import { useTransition } from '@/shared/hooks/useCinematicTransition';
import { OptionCard } from '../components/OptionCard';

export function Arena() {
  const { fadeTo } = useTransition();

  useEffect(() => {
    document.title = 'The Floor Is Yours — The Arena';
  }, []);

  return (
    <main className="scene">
      <div
        className="scene__image scene__image--arena"
        role="img"
        aria-label="A grand classical arena beneath a luminous sky"
      />
      <div className="scene__vignette" />

      <SceneBack />

      <div className="scene__content">
        <p className="scene__eyebrow">— Choose your path —</p>
        <h1 className="scene__title">How will you engage?</h1>

        <div className="scene__options">
          <OptionCard
            variant="watch"
            eyebrow="Spectate"
            title="Watch a Debate"
            description="Witness two minds clash. Choose the figures, choose the topic, take your seat in the stands."
            cta="Begin"
            onSelect={() =>
              fadeTo({ to: '/arena/watch', title: 'The Stands — The Arena' })
            }
          />
          <OptionCard
            variant="spar"
            eyebrow="Engage"
            title="Step Into the Ring"
            description="Defend your own views against a figure who will not yield. The floor is yours."
            cta="Begin"
            onSelect={() =>
              fadeTo({ to: '/arena/spar', title: 'The Ring — The Arena' })
            }
          />
        </div>
      </div>
    </main>
  );
}
